<div class="scrollable-menu">
	<div class="subheader">
		@for (menuButton of topMenu; let i = $index; track i) {
            @if(menuButton.dropdown) {
                <button mat-flat-button [matMenuTriggerFor]="matMenu" [attr.aria-label]="menuButton.label" 
                    class="menu-button default-button {{menuButton.cssClass}}" 
                    [class.active]="isMenuItemActive(menuButton)">
                <div class="subheader-button">
                    <img [src]="menuButton.icon" [alt]="menuButton.label + '-icon'" width="18px" height="18px">
                    <span title="{{menuButton.title}}" class="thin-text default-text">{{menuButton.label}}</span>
                    <mat-icon iconPositionEnd class="default-text-icon">expand_more</mat-icon>
                </div>
                </button>
                <mat-menu #matMenu="matMenu" xPosition="before" class="subheader-menu">
                @for (menuItem of menuButton.dropdown; let i = $index; track i) {
                    @if (menuItem.command) {
                    <button mat-menu-item [attr.aria-label]="menuItem.label" 
                        class="subheader-menu-item" 
                        [class.active]="activeItem() === menuItem.route"
                        (click)="executeCommand(menuItem.command, menuItem.route)">{{menuItem.label}}</button>
                    } @else {
                    <button mat-menu-item [attr.aria-label]="menuItem.label" 
                        class="subheader-menu-item" 
                        [class.active]="activeItem() === menuItem.route"
                        (click)="navigatePage(menuItem.route); setActiveItem(menuItem.route)">{{menuItem.label}}</button>
                    }
                }
                </mat-menu>
            } @else {
                <button mat-flat-button class="menu-button default-button" 
                    [attr.aria-label]="menuButton.label" 
                    [class.active]="activeItem() === menuButton.route"
                    (click)="navigatePage(menuButton.route)">
                <div class="subheader-button">
                    <img [src]="menuButton.icon" [alt]="menuButton.label + '-icon'" width="18px" height="18px">
                    <span class="thin-text default-text">{{menuButton.label}}</span>
                </div>
                </button>
            }
        }
	</div>
</div>
